var _defs, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _polygon2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIco4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 123 123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#074ea3;}.cls-2{fill:#013177;}.cls-3{fill:#00a4e3;}.cls-4{fill:#fff;}.cls-5{fill:#33c3ef;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.77,37.09,61.81,26a.94.94,0,0,0-.62,0l-31,11.13a.93.93,0,0,0-.6.86.91.91,0,0,0,.6.86L61.19,50a1,1,0,0,0,.62,0l31-11.14a.91.91,0,0,0,.6-.86A.93.93,0,0,0,92.77,37.09Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.81,48.23l-31-11.14a.91.91,0,0,0-.83.12.89.89,0,0,0-.39.74V77.61a.9.9,0,0,0,.56.84l31,13.12a.94.94,0,0,0,.36.08.9.9,0,0,0,.5-.16.88.88,0,0,0,.41-.76V49.09A.91.91,0,0,0,61.81,48.23Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93,37.21a.91.91,0,0,0-.83-.12l-31,11.14a.91.91,0,0,0-.6.86V90.73a.91.91,0,0,0,.91.92,1,1,0,0,0,.37-.08l31-13.9a.91.91,0,0,0,.54-.83V38A.89.89,0,0,0,93,37.21Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.61,76H70.11a.92.92,0,0,0-.92.91V89.15a8,8,0,0,0,8,7.94h5.44a8,8,0,0,0,7.94-7.94V76.91A.91.91,0,0,0,89.61,76Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.85,78.13H73.09a1.22,1.22,0,0,1-1.21-1.22v-8a8.1,8.1,0,0,1,16.19,0v8A1.22,1.22,0,0,1,86.85,78.13ZM74.31,75.69H85.64V68.88a5.67,5.67,0,0,0-11.33,0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M82.54,84.08a2.68,2.68,0,1,0-3.68,2.48h0v3.71h2v-3.7A2.68,2.68,0,0,0,82.54,84.08Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "50.97 45.3 81.37 32.99 71.53 29.46 40.31 41.47 50.97 45.3"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "40.31 41.47 40.31 82.83 50.97 87.28 50.97 45.3 40.31 41.47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco4);
export default __webpack_public_path__ + "static/media/ico-4.dc38e7a724f5b28014ca4f749f66eedb.svg";
export { ForwardRef as ReactComponent };